import { LinkConfirmation } from '@piconetworks/login'
import withInjection from '@piconetworks/with-injection'

const mapStateToProps = (state, props) => ({
    ...props,
    name: state?.loader?.guest?.publisher?.name,
})

const InjectedLinkConfirmation = withInjection(LinkConfirmation, {
    mapStateToProps,
})

export default InjectedLinkConfirmation
